export const SAVE_TUTORIAL_DATA = "SAVE_TUTORIAL_DATA";
export const FETCH_TUTORIAL_DATA = "FETCH_TUTORIAL_DATA";